//
//
//
//

export default {
  name: 'badge',
  props: {
    text: [String, Number]
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/badge/index.vue